import { ActionType, EntityType, ModuleType } from "../../../queryKeyFactory";
import { tarrifFilters } from "@features/onboarding/utility-setup/components/plan-tariffs/components/Tarrif/types";
export const planTarrifKeyFactory = {
  rateTypes: (): [ModuleType, EntityType] => ["onboarding", "rateTypes"],
  basisTypes: (rateType: string): [ModuleType, EntityType, string] => [
    "onboarding",
    "basisTypes",
    rateType,
  ],
  rateTable: (
    filters?: tarrifFilters
  ): [ModuleType, EntityType, ActionType, tarrifFilters] => [
    "onboarding",
    "rateList",
    "list",
    filters,
  ],
  planVersion: (
    planId: number,
    page: number,
    pageSize: number
  ): [ModuleType, ActionType, number, number, number] => [
    "onboarding",
    "list",
    planId,
    page,
    pageSize,
  ],

  planTable: (
    filters?: tarrifFilters
  ): [ModuleType, EntityType, ActionType, tarrifFilters] => [
    "onboarding",
    "planList",
    "list",
    filters,
  ],
  planDetail: (planId?: any): [ModuleType, "detail", any] => [
    "onboarding",
    "detail",
    planId,
  ],
  billFrequency: (): [ModuleType, EntityType] => [
    "onboarding",
    "billFrequency",
  ],

  createdUserNames: (): [ModuleType, EntityType] => [
    "onboarding",
    "createdUserNames",
  ],

  taxType: (): [ModuleType, EntityType] => ["onboarding", "taxType"],
  category: (): [ModuleType, EntityType] => ["onboarding", "category"],
  subCategory: (categoryCode: string) => [
    "plan-tariff",
    "subcategory",
    categoryCode,
  ],
  rateNames: (rateTypeKey: string) => ["plan-tariff", "rateNames", rateTypeKey],
  serviceCharges: () => ["plan-tariff", "serviceCharges"],
  recentlyUpdatedRates: (page: number): [ModuleType, EntityType, number] => [
    "onboarding",
    "recentlyUpdatedRates",
    page,
  ],
  recentlyUpdatedPlans: (page: number) => [
    "onboarding",
    "planTarrif",
    "recentlyUpdatedPlans",
    page,
  ],

  planKPIs: (): [ModuleType, EntityType] => ["onboarding", "planKPIs"],
  rateDetail: (id: number): [ModuleType, EntityType, number] => [
    "onboarding",
    "rateDetail",
    id,
  ],
};
